export default {
    init() {
        this.login();
        this.register();
        this.verifyAccount();
    },
    login() {
        $('body').on('submit','#login-form form#login, #login-form-modal form#login', event => {
            event.preventDefault();
        });
        $('body').on('click', '#login-form button[type="submit"], #login-form-modal form#login button[type="submit"]', function (e) {
            e.preventDefault();
            const data = $(e.currentTarget).parents('form').serialize();
            const parentForm = $(e.currentTarget).parents('form');
            $.ajax({
                type: 'POST',
                url: '/login',
                data: data,
                success: function () {
                    location.href = '/login';
                },
                error: function (response) {
                    if (response.responseJSON.errors) {
                        let errors = '<div class="row"><div class="col-12"><div class="mb-3 error-container" role="alert">';
                        $.each(response.responseJSON.errors, function (index, value) {
                            errors += `<p class="error-message">${value}</p>`;
                        });
                        errors += '</div></div></div>';
                        $(parentForm).find('.validation-errors').html(errors);
                    }else{
                        $(parentForm).find('.validation-errors').html('');
                    }
                    if (response.responseJSON.need_verify) {
                        $('#multifactor-autentication-modal').modal('show');
                        $('#multifactor-autentication-modal').find('#_token').val(response.responseJSON.user_token)
                        $('#multifactor-autentication-modal').find('.phone').text(response.responseJSON.phone)
                        $('#login-form-modal').modal('hide');
                    }
                }
            });
        });
    },
    register() {
        $('body').on('click', '#register-form-modal button[type="submit"]', function (e) {
            let submitButton = $(this);
            submitButton.hide();
            e.preventDefault();
            $('#register-form-modal form input[name=lead_source]').val(getCookieLayout('lead_source'));
            $.ajax({
                type: 'POST',
                url: '/register',
                data: $('#register-form-modal form').serialize(),
                success: function (data) {
                    submitButton.show();
                    location.href = '/create-organisation';
                },
                error: function (response) {
                    submitButton.show();
                    let errors = '<div class="row"><div class="col-12"><div class="alert alert-danger" role="alert">';
                    $.each(response.responseJSON.errors, function (index, value) {
                        errors += '<p><strong>' + value + '</strong></p>';
                    });
                    errors += '</div></div></div>';
                    $('#register-form-modal .validation-errors').html(errors);
                }
            });
        });
    },
    verifyAccount(){
        $('#multifactor-autentication-modal form').on('submit', (e)=>{
            e.preventDefault();
        });
        $('#multifactor-autentication-modal .verify_account_btn').click(function() {
            $.ajax({
                type: 'POST',
                url: '/multifactor-verify',
                data: {
                    code: $('#multifactor-autentication-modal').find('#multifactor-verification-code').val(),
                    token: $('#multifactor-autentication-modal').find('#_token').val(),
                },
                success: function () {
                    location.href = '/login';
                },
                error: function (response) {
                    if (response.responseJSON.errors) {
                        let errors = '<div class="row"><div class="col-12"><div class="alert alert-danger" role="alert">';
                        $.each(response.responseJSON.errors, function (index, value) {
                            errors += '<p><strong>' + value + '</strong></p>';
                        });
                        errors += '</div></div></div>';
                        $('#login-form-modal .validation-errors').html(errors);
                    }
                    if (response.responseJSON.message) {
                        $('#multifactor-autentication-modal .status-info').removeClass('d-none').text(response.responseJSON.message);
                        if (response.responseJSON.need_resend) {
                            $('#multifactor-autentication-modal .resend-code-btn').parent().removeClass('d-none');
                        }
                    }
                }
            });
        });
        $('#multifactor-autentication-modal .resend-code-btn').click(function() {
            $.ajax({
                type: 'POST',
                url: '/resend-verification-code',
                success: ()=> {
                    $('#multifactor-autentication-modal .status-info').text('').addClass('d-none');
                    $(this).parent().addClass('d-none');
                },
                error: function (response) {
                }
            });
        });
        $('#multifactor-autentication-modal .back-login-btn').click(function() {
            $('#multifactor-autentication-modal').modal('hide')
            $('#login-form-modal').modal('show');
        });
    }
}
